import { formatPhoneNumber } from '../functions/phoneNumber';

const telephoneNumber = (value, def) => formatPhoneNumber(value, def);

export default telephoneNumber;
